import React, { useEffect, useState } from "react";
import "./NewChatBot_Dashboard.css";
import { useNavigate } from "react-router-dom";
import { routePath as RP } from "../../app/routes/routepath";

import {checkSystemHealthCheck} from "../../Api_Qdrant/Fast_apis";
import {
  GetDashboardCountSql,
  GetRecentConnection,
  //GetTotalDocuments
} from "../../Apis_chatbot/apis";

import { Check, X, RefreshCw, Activity, Database, Server, Brain, Mail, Layers, Zap, CircleDot, AlertTriangle, ScrollText } from "lucide-react";

import totalAnsweredSvg from "../../assets/icons/total-unanswerd.svg";
import conversationTodaySvg from "../../assets/icons/conversation-today.svg";
import totalGuestUserSvg from "../../assets/icons/total-guest-users.svg";
import totalLoggedUser from "../../assets/icons/active-users.svg";
import LoadingSpinner from "../../app/components/Loader/LoadingSpinner";
import DeletedSvg from "../../assets/icons/deleted.svg";
import pendingDeleteIcon from "../../assets/icons/delete_pending.svg";
import pendingIcon from "../../assets/icons/pending.svg";
import editPendingIcon from "../../assets/icons/edit_pending.svg";
import completedDocumentsSvg from "../../assets/icons/completedDocuments.svg";
import detectedClient from "../../assets/icons/detectedClient.svg";


function NewChatbotDashboard() {
  const navigate = useNavigate();

  /* =========================================================
     DASHBOARD STATE
  ========================================================= */

  const [showBot, setShowBot] = useState(true);
  const [showDashboard, setShowDashboard] = useState(false);

  const [recentUsers, setRecentUsers] = useState([]);
  const [healthCheckFailed, setHealthCheckFailed] = useState(false);
  const [dashboardData, setDashboardData] = useState({
    total_qa: 0,
  });

  const [dashboardDatasql, setDashboardDatasql] = useState({
    total_unanswered_qa: 0,
    total_conversations: 0,
    total_guest_users: 0,
    total_logged_users: 0,
    total_completed_documents: 0,
    total_pending_documents: 0,
    total_delete_pending_documents: 0,
    total_deleted_documents: 0,
    total_edit_pending_documents: 0,
    total_Detected_Client_Today: 0,
  });

  const [isLoading, setIsLoading] = useState(true);

  /* =========================================================
     HEALTH CHECK STATE
  ========================================================= */

  const [healthData, setHealthData] = useState(null);

  const [healthLoading, setHealthLoading] = useState(false);

  const [visibleHealthChecks, setVisibleHealthChecks] = useState([]);

  const [healthComplete, setHealthComplete] = useState(false);

  const username = localStorage.getItem("username") || "Admin";

  /* =========================================================
     INITIAL LOAD
  ========================================================= */
useEffect(() => {
  const loadDashboard = async () => {
    try {
      await Promise.all([fetchDashboardDataSql(), fetchGetRecentConnection()]);
    } finally {
      setIsLoading(false);
    }
  };

  loadDashboard();
  runHealthCheck();
}, []);

  /* =========================================================
     DASHBOARD SQL DATA
  ========================================================= */

  const fetchDashboardDataSql = async () => {
    try {
      const res = await GetDashboardCountSql();

      if (res) {
        const data = res.result_value;

        setDashboardDatasql({
          total_unanswered_qa: data?.totalUnansweredQuestions || 0,

          total_conversations: data?.totalConnectionsToday || 0,

          total_guest_users: data?.totalGuestUsers || 0,

          total_logged_users: data?.totalLoggedUsers || 0,

          total_completed_documents: data?.totalCompletedDocument || 0,

          total_pending_documents: data?.totalPendingDocument || 0,

          total_delete_pending_documents: data?.totalDeletePendingDocument || 0,

          total_deleted_documents: data?.totalDeletedDocument || 0,

          total_edit_pending_documents: data?.totalEditPendingDocument || 0,

          total_Detected_Client_Today: data?.totalDetectedClientToday || 0,
        });
      }
    } catch (error) {
      console.error("Dashboard SQL error:", error);
    }
  };

  /* =========================================================
     RECENT CONNECTIONS
  ========================================================= */

  const fetchGetRecentConnection = async () => {
    try {
      const res = await GetRecentConnection();

      if (res) {
        setRecentUsers(res.result_value || []);
      }
    } catch (error) {
      console.error("Recent connection error:", error);
    }
  };

  /* =========================================================
     GENERATED QA
  ========================================================= */

  // const fetchDashboardData = async () => {
  //   try {
  //     const response = await GetTotalGeneratedQA();

  //     if (response) {
  //       setDashboardData({
  //         total_qa: response?.result?.active_count || 0,
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Generated QA error:", error);
  //   }
  // };

  /* =========================================================
     SYSTEM HEALTH CHECK
  ========================================================= */

const runHealthCheck = async () => {
  setHealthLoading(true);
  setHealthComplete(false);
  setHealthData(null);
  setVisibleHealthChecks([]);
  setHealthCheckFailed(false);

  try {
    const response = await checkSystemHealthCheck();

    if (response?.data && response?.data?.checks) {
      const data = response.data;
      setHealthData(data);

      const checks = Object.entries(data.checks);
      checks.forEach(([service], index) => {
        setTimeout(() => {
          setVisibleHealthChecks((previous) => [...previous, service]);
        }, index * 650);
      });

      setTimeout(() => {
        setHealthComplete(true);
        setHealthLoading(false);
      }, checks.length * 650 + 500);
    } else {
      // response came back, but not in the shape we expect (e.g. 500 body, empty payload)
      console.error("Health check returned unexpected shape:", response);
      setHealthLoading(false);
      setHealthCheckFailed(true);   // <-- this was missing
    }
  } catch (error) {
    console.error("Health check failed:", error);
    setHealthLoading(false);
    setHealthCheckFailed(true);
  }
};

  /* =========================================================
     HEALTH ICON
  ========================================================= */

  const getHealthIcon = (service) => {
    const icons = {
      redis: Zap,

      database: Database,

      qdrant: Layers,

      groq: Brain,

      embeddings: Activity,

      email: Mail,

      openai: Brain,

      gemini: Brain,
    };

    return icons[service] || Server;
  };

  /* =========================================================
     SERVICE NAME
  ========================================================= */

  const formatServiceName = (service) => {
    const names = {
      redis: "Redis",

      database: "Database",

      qdrant: "Qdrant Vector DB",

      groq: "Groq LLM",

      embeddings: "Embedding Model",

      email: "Email Service",

      openai: "OpenAI",

      gemini: "Gemini",
    };

    return names[service] || service;
  };

  /* =========================================================
     OVERALL STATUS
  ========================================================= */

const getOverallStatus = () => {
  if (healthCheckFailed) return "error";
  if (healthLoading) return "checking";
  if (!healthData) return "checking";
  if (healthData.status === "ok") return "healthy";
  if (healthData.status === "degraded") return "degraded";
  return "critical";
};

  /* =========================================================
     STATUS TEXT
  ========================================================= */

const getStatusTitle = () => {
  if (healthCheckFailed) return "DIAGNOSTIC FAILED";
  if (healthLoading) return "SYSTEM DIAGNOSTIC IN PROGRESS";
  if (!healthData) return "WAITING FOR DIAGNOSTICS";
  if (healthData.status === "ok") return "ALL SYSTEMS OPERATIONAL";
  if (healthData.status === "degraded") return "SYSTEM DEGRADED";
  return "SYSTEM CRITICAL";
};

  /* =========================================================
     RENDER
  ========================================================= */

  return (
    <>
     {isLoading ? (
        <LoadingSpinner />
      ) : (
        <div className="dashboard_main">
            <div className="dashboard_content">
              {/* =================================================
                  PAGE HEADER
              ================================================= */}

              <div className="chatdash-page-header">
                <h2 className="mb-0">Overview</h2>

                <button
                  className="chatdash-logs-btn"
                  onClick={() => navigate(RP.systemLogs)}
                >
                  <ScrollText size={16} />
                  System Logs
                </button>
              </div>

              {/* =================================================
                  SUMMARY CARDS
              ================================================= */}

              <div className="dashboard_details_card_wraper">
                {/* Unanswered */}

                {/* <div className="dashboard_details_card">
                  <div className="dashboard_details_card_inner_wraper">
                    <div className="dashboard_details_card_img">
                      <img src={totalAnsweredSvg} alt="Total unanswered" />

                      <p>Total Unanswered QA</p>
                    </div>

                    <div className="dashboard_card_requested_text">
                      <span>{dashboardDatasql.total_unanswered_qa}</span>

                      <p>Uploaded</p>
                    </div>
                  </div>
                </div> */}

                {/* Generated QA */}

                {/* <div className="dashboard_details_card">
                  <div className="dashboard_details_card_inner_wraper">
                    <div className="dashboard_details_card_img">
                      <img src={totalAnsweredSvg} alt="Q&A" />

                      <p>Q&A</p>
                    </div>

                    <div className="dashboard_card_requested_text">
                      <span>{dashboardData.total_qa}</span>

                      <p>Generated</p>
                    </div>
                  </div>
                </div> */}

                {/* Conversations */}

                <div className="dashboard_details_card">
                  <div className="dashboard_details_card_inner_wraper">
                    <div className="dashboard_details_card_img">
                      <img src={conversationTodaySvg} alt="Conversations" />

                      <p>Conversations Today</p>
                    </div>

                    <div className="dashboard_card_requested_text">
                      <span>{dashboardDatasql.total_conversations}</span>

                      <p>with Agent</p>
                    </div>
                  </div>
                </div>

                {/* Guest Users */}

                <div className="dashboard_details_card">
                  <div className="dashboard_details_card_inner_wraper">
                    <div className="dashboard_details_card_img">
                      <img src={totalGuestUserSvg} alt="Guest users" />

                      <p>Total Guest Users</p>
                    </div>

                    <div className="dashboard_card_requested_text">
                      <span>{dashboardDatasql.total_guest_users}</span>
                    </div>
                  </div>
                </div>

                {/* Logged Users */}

                <div className="dashboard_details_card">
                  <div className="dashboard_details_card_inner_wraper">
                    <div className="dashboard_details_card_img">
                      <img src={totalLoggedUser} alt="Logged users" />

                      <p>Total Logged Users</p>
                    </div>

                    <div className="dashboard_card_requested_text">
                      <span>{dashboardDatasql.total_logged_users}</span>
                    </div>
                  </div>
                </div>

                {/* Completed Documents */}

                <div className="dashboard_details_card">
                  <div className="dashboard_details_card_inner_wraper">
                    <div className="dashboard_details_card_img">
                      <img src={completedDocumentsSvg} alt="Completed documents" />

                      <p>Active Documents</p>
                    </div>

                    <div className="dashboard_card_requested_text">
                      <span>{dashboardDatasql.total_completed_documents}</span>
                    </div>
                  </div>
                </div>

                {/* Pending Documents */}

                <div className="dashboard_details_card">
                  <div className="dashboard_details_card_inner_wraper">
                    <div className="dashboard_details_card_img">
                      <img src={pendingIcon} alt="Pending documents" />

                      <p>Upload Pending Documents</p>
                    </div>

                    <div className="dashboard_card_requested_text">
                      <span>{dashboardDatasql.total_pending_documents}</span>
                    </div>
                  </div>
                </div>

                {/* Edit Pending Documents */}
{/* 
                <div className="dashboard_details_card">
                  <div className="dashboard_details_card_inner_wraper">
                    <div className="dashboard_details_card_img">
                      <img src={editPendingIcon} alt="Edit pending documents" />

                      <p>Edit Pending Documents</p>
                    </div>

                    <div className="dashboard_card_requested_text">
                      <span>{dashboardDatasql.total_edit_pending_documents}</span>
                    </div>
                  </div>
                </div> */}

                {/* Delete Pending Documents */}
{/* 
                <div className="dashboard_details_card">
                  <div className="dashboard_details_card_inner_wraper">
                    <div className="dashboard_details_card_img">
                      <img src={pendingDeleteIcon} alt="Delete pending documents" />

                      <p>Delete Pending Documents</p>
                    </div>

                    <div className="dashboard_card_requested_text">
                      <span>{dashboardDatasql.total_delete_pending_documents}</span>
                    </div>
                  </div>
                </div> */}

                {/* Deleted Documents */}

                <div className="dashboard_details_card">
                  <div className="dashboard_details_card_inner_wraper">
                    <div className="dashboard_details_card_img">
                      <img src={DeletedSvg} alt="Deleted documents" />

                      <p>Deleted Documents</p>
                    </div>

                    <div className="dashboard_card_requested_text">
                      <span>{dashboardDatasql.total_deleted_documents}</span>
                    </div>
                  </div>
                </div>
              

              {/* Today detected clients */}

              <div className="dashboard_details_card">
                  <div className="dashboard_details_card_inner_wraper">
                    <div className="dashboard_details_card_img">
                      <img src={detectedClient} alt="Today Detected Clients" />

                      <p>Today Detected Clients</p>
                    </div>

                    <div className="dashboard_card_requested_text">
                      <span>{dashboardDatasql.total_Detected_Client_Today}</span>
                    </div>
                  </div>
                </div>
            </div>

              {/* =================================================
                  SYSTEM HEALTH
              ================================================= */}

              <div className="dashboard-chart-main-wraper chat-dashboard-chart-main-wraper">
                <div className="health-dashboard">
                  {/* ================= HEADER ================= */}

                  <div className="health-header">
                    <div className="health-title-section">
                      <div className="health-main-icon">
                        <Activity size={22} />
                      </div>

                      <div>
                        <h2>System Health</h2>

                        <p>Real-time backend service monitoring</p>
                      </div>
                    </div>

                    <button
                      className={`health-refresh-btn ${
                        healthLoading ? "refreshing" : ""
                      }`}
                      onClick={runHealthCheck}
                      disabled={healthLoading}
                    >
                      <RefreshCw size={16} />

                      {healthLoading ? "Scanning..." : "Run Diagnostics"}
                    </button>
                  </div>

                  {/* ================= OVERALL STATUS ================= */}

                  <div
                    className={`health-overall-status ${getOverallStatus()}`}
                  >
                    <div className="health-status-icon">
                     {healthLoading ? (
                          <CircleDot className="scanning-dot" size={28} />
                        ) : healthCheckFailed ? (
                          <AlertTriangle size={30} />
                        ) : getOverallStatus() === "healthy" ? (
                          <Check size={30} />
                        ) : getOverallStatus() === "degraded" ? (
                          <Activity size={30} />
                        ) : (
                          <X size={30} />
                        )}
                    </div>

                    <div className="health-status-text">
                      <span className="health-status-label">
                        {getStatusTitle()}
                      </span>

                      <small>
                        {healthCheckFailed
                          ? "Could not reach the backend health endpoint (server error or network failure)"
                          : healthLoading
                            ? "Checking backend dependencies..."
                            : healthData?.status === "degraded"
                              ? "Some services require attention"
                              : healthData?.status === "ok"
                                ? "All monitored services are responding normally"
                                : "Waiting for health diagnostics"}
                      </small>
                    </div>

                    {!healthLoading && healthData && (
                      <div className="health-status-badge">
                        {healthData.status.toUpperCase()}
                      </div>
                    )}
                  </div>

                  {/* ================= SERVICE CHECKS ================= */}

                  <div className="health-check-list">
                    {healthData &&
                      Object.entries(healthData.checks || {}).map(
                        ([service, check], index) => {
                          const isVisible =
                            visibleHealthChecks.includes(service);

                          const Icon = getHealthIcon(service);

                          const allChecks = Object.entries(healthData.checks);

                          return (
                            <div
                              key={service}
                              className={`health-check-item ${
                                isVisible ? "health-check-visible" : ""
                              } ${
                                isVisible && check.status === "ok"
                                  ? "health-check-success"
                                  : ""
                              } ${
                                isVisible && check.status === "fail"
                                  ? "health-check-failed"
                                  : ""
                              }`}
                            >
                              {/* Connecting line */}

                              {index !== allChecks.length - 1 && (
                                <div className="health-connector" />
                              )}

                              {/* Service icon */}

                              <div className="health-service-icon">
                                <Icon size={18} />
                              </div>

                              {/* Information */}

                              <div className="health-service-info">
                                <div className="health-service-name">
                                  {formatServiceName(service)}
                                </div>

                                <div className="health-service-message">
                                  {!isVisible ? (
                                    <span className="health-scanning">
                                      <span />
                                      SCANNING
                                    </span>
                                  ) : (
                                    <>
                                      <span>
                                        {check.message || "No message"}
                                      </span>

                                      {check.latency_ms !== undefined && (
                                        <span className="health-latency">
                                          {check.latency_ms} ms
                                        </span>
                                      )}
                                    </>
                                  )}
                                </div>

                                {/* Error */}

                                {isVisible && check.status === "fail" && (
                                  <div className="health-error">
                                    <strong>
                                      {check.code || "SERVICE_ERROR"}
                                    </strong>

                                    {check.error && <span>{check.error}</span>}

                                    {check.upstream_status && (
                                      <span>HTTP {check.upstream_status}</span>
                                    )}
                                  </div>
                                )}
                              </div>

                              {/* Result */}

                              <div className="health-result">
                                {!isVisible ? (
                                  <div className="health-loader">
                                    <span />
                                    <span />
                                    <span />
                                  </div>
                                ) : check.status === "ok" ? (
                                  <div className="health-check-animation">
                                    <Check size={19} strokeWidth={3} />
                                  </div>
                                ) : (
                                  <div className="health-fail-animation">
                                    <X size={19} strokeWidth={3} />
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        },
                      )}
                  </div>

                  {/* ================= FOOTER ================= */}

                  {healthComplete && healthData && (
                    <div className="health-footer">
                      <div className="health-footer-line" />

                      <span>
                        Last checked{" "}
                        {new Date(healthData.timestamp).toLocaleTimeString()}
                      </span>

                      <div className="health-footer-line" />
                    </div>
                  )}
                </div>
              </div>

              {/* =================================================
                  RECENT CONVERSATIONS
              ================================================= */}

              <div className="role-box">
                <h2 className="mb-0">Recent Conversations</h2>
              </div>

              <div className="main_widget">
                <div className="main_widget_body">
                  <div className="table-responsive">
                    <table>
                      <thead>
                        <tr>
                          <th>S.No.</th>

                          <th>User's Name</th>

                          <th>Agent Name</th>

                          <th>Chat Start Time</th>

                          <th>Chat End Time</th>
                        </tr>
                      </thead>

                      <tbody>
                        {recentUsers && recentUsers.length > 0 ? (
                          recentUsers.map((user, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>

                              <td>{user.userName || "-"}</td>

                              <td>{user.agentName || "-"}</td>

                              <td>
                                {user.startedAt
                                  ? new Date(user.startedAt).toLocaleString(
                                      undefined,
                                      {
                                        year: "numeric",
                                        month: "short",
                                        day: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                      },
                                    )
                                  : "-"}
                              </td>

                              <td>
                                {user.endedAt ? (
                                  new Date(user.endedAt).toLocaleString(
                                    undefined,
                                    {
                                      year: "numeric",
                                      month: "short",
                                      day: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    },
                                  )
                                ) : (
                                  <span
                                    style={{
                                      color: "green",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Still Running
                                  </span>
                                )}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan="5"
                              style={{
                                textAlign: "center",
                              }}
                            >
                              No users found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
        </div>
      )}
    </>
  );
}

export default NewChatbotDashboard;
